import * as React from "react"
const SvgDelete = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7 21.857q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 19.857v-13a.97.97 0 0 1-.713-.287A.97.97 0 0 1 4 5.857a.97.97 0 0 1 .287-.712A.97.97 0 0 1 5 4.857h4a.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288h4a.97.97 0 0 1 .713.288.97.97 0 0 1 .287.712h4q.424 0 .712.288.288.287.288.712c0 .425-.096.521-.288.713a.97.97 0 0 1-.712.287v13a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587zm10-15H7v13h10zm-7 11q.424 0 .713-.287a.97.97 0 0 0 .287-.713v-7a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712v7a.97.97 0 0 0 .287.713q.288.287.713.287m4 0q.424 0 .713-.287a.97.97 0 0 0 .287-.713v-7a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712v7a.97.97 0 0 0 .287.713q.288.287.713.287" />
  </svg>
)
export default SvgDelete
